export default {
  en: {
    editInformation: 'Edit Information',
    hotelInformation: 'Information',
    code: 'Code',
    name: 'Name',
    address: 'Address',
    email: 'Email',
    tel: 'Tel',
    fax: 'Fax',
    changeInformation: 'Change Information',
    addEmail: '+ Add Email',
    addTel: '+ Add Tel.',
    addFax: '+ Add Fax.',
    saveChange: 'Save Changes',
    cancel: 'Cancel',
    saveHotelInfoSuccessTitle: 'Success',
    saveHotelInfoSuccessMessage: 'Update Hotel Info Success.',
    remarkImageSize: '* Image size < 5MB',
    imageSizeOverMessage: 'Image size must be smaller than 5MB'
  },
  th: {
    editInformation: 'แก้ไขรายละเอียดโรงแรม',
    hotelInformation: 'รายละเอียดโรงแรม',
    code: 'โค้ด',
    name: 'ชื่อ',
    address: 'ที่อยู่',
    email: 'อีเมล',
    tel: 'โทร.',
    fax: 'แฟกซ์',
    changeInformation: 'แก้ไขข้อมูล',
    addEmail: '+ เพิ่มอีเมล',
    addTel: '+ เพิ่มโทร',
    addFax: '+ เพิ่มแฟกซ์',
    saveChange: 'บันทึก',
    cancel: 'ยกเลิก',
    saveHotelInfoSuccessTitle: 'บันทึกสำเร็จ',
    saveHotelInfoSuccessMessage: 'แก้ไขรายละเอียดโรงแรมสำเร็จ',
    remarkImageSize: 'ขนาดรูปภาพ < 5MB',
    imageSizeOverMessage: 'ขนาดรูปภาพต้องไม่เกิน 5MB'
  }
}
